<template>
    <div class="" v-if="items.length>0">
        <h2>Обучение педагогов и воспитателей кадетских классов на курсах повышения квалификации в рамках Проекта</h2>
        <br/>
        <table>
            <thead>
            <tr>
                <th>Название учебного курса</th>
                <th>Организация, проводившая курсы</th>
                <th>Количество часов</th>
                <th>Количество учителей (работающих в проекте), прошедших обучение</th>
                <th>Количество воспитателей кадетских классов (работающих в проекте), прошедших обучение</th>
            </tr>
            </thead>
            <tbody>
            <tr v-bind:key="item.id" v-for="item in items">
                <td>{{item.name}}</td>
                <td>{{item.organization}}</td>
                <td>{{item.hours}}</td>
                <td>{{item.numberTeachers}}</td>
                <td>{{item.numberEducators}}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>


<script>
    import Request from 'superagent';

    export default {

        data() {
            return {
                items: []
            };
        },


        created() {
            this.getItems();
        },


        methods: {
            getItems() {
                var path = this.$store.state.api + this.$store.state.apiCadetCourse + "?eoId=" + this.$store.state.eoId;
                var $this = this;
                Request
                    .get(path)
                    .then((res) => {
                        if (res.status == 200) {
                            if (res.body.result == "success") {
                                $this.items = res.body.data;
                            }
                        }
                    });
            }
        }

    }
</script>


<style>

</style>
